// src/components/ProtectedRoute.jsx
// BUG WAS HERE: `authLoading` does not exist in context — it's always
// undefined (falsy), so the loading guard was never triggered and the
// component immediately redirected on hard refresh.
// FIX: use `isInitializing` which AppContext now exposes.

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useApp } from '../contexts/AppContext';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, isInitializing } = useApp(); // ← was authLoading
  const location = useLocation();

  // Auth state not yet known — wait before making any redirect decision
  if (isInitializing) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;


// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { CircularProgress, Box } from '@mui/material';
// import { useApp } from '../contexts/AppContext';

// const ProtectedRoute = ({ children, requireAuth = true }) => {
//   const { isAuthenticated, authLoading } = useApp();
//   const location = useLocation();

//   if (authLoading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (requireAuth && !isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   if (!requireAuth && isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

